import { useEffect } from 'react';

export default function MobileOptimizer() {
  useEffect(() => {
    // Mobile viewport optimization
    const viewport = document.querySelector('meta[name="viewport"]');
    if (viewport) {
      viewport.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=5.0, user-scalable=yes');
    }

    // Prevent 300ms delay on mobile taps
    document.addEventListener('touchstart', () => {}, { passive: true });

    // Optimize form inputs for mobile - use matchMedia to avoid forced reflow
    const mql = window.matchMedia('(max-width: 767px)');
    const inputs = document.querySelectorAll('input, select, textarea');
    inputs.forEach(input => {
      // Improve touch targets
      input.addEventListener('focus', () => {
        // Use cached matchMedia result instead of reading window.innerWidth
        if (mql.matches) {
          setTimeout(() => {
            input.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }, 300);
        }
      });
    });

    // Note: PWA caching removed - was causing production errors by trying to cache /src/* paths

    // Mobile-specific performance monitoring
    if ('connection' in navigator) {
      const connection = (navigator as any).connection;
      if (connection && connection.effectiveType) {
        console.log('Connection type:', connection.effectiveType);
        
        // Adapt behavior based on connection speed
        if (connection.effectiveType === 'slow-2g' || connection.effectiveType === '2g') {
          document.body.classList.add('slow-connection');
        }
        
        // Add data saver mode for low bandwidth
        if (connection.saveData || connection.effectiveType === 'slow-2g') {
          document.body.classList.add('data-saver-mode');
          
          // Disable animations on slow connections
          const style = document.createElement('style');
          style.textContent = `
            .data-saver-mode * {
              animation-duration: 0.01ms !important;
              animation-iteration-count: 1 !important;
              transition-duration: 0.01ms !important;
            }
          `;
          document.head.appendChild(style);
        }
      }
    }

    // iOS Safari specific optimizations
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    if (isIOS) {
      // Fix viewport issues on iOS - use RAF to batch reads/writes and avoid forced reflow
      let rafId: number | null = null;
      
      const fixViewport = () => {
        if (rafId) return; // Debounce rapid calls
        rafId = requestAnimationFrame(() => {
          const vh = window.innerHeight * 0.01;
          document.documentElement.style.setProperty('--vh', `${vh}px`);
          rafId = null;
        });
      };
      
      fixViewport();
      window.addEventListener('resize', fixViewport, { passive: true });
      window.addEventListener('orientationchange', () => {
        setTimeout(fixViewport, 100);
      }, { passive: true });

      return () => {
        if (rafId) cancelAnimationFrame(rafId);
        window.removeEventListener('resize', fixViewport);
        window.removeEventListener('orientationchange', fixViewport);
      };
    }
  }, []);

  return null;
}